import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from './use-tenant-feature-flags';

export function resolveHotelAccess({
  isHotelEnabled,
  canAccessHotel,
  canWrite,
  isLoading,
}: {
  isHotelEnabled: boolean;
  canAccessHotel: boolean;
  canWrite: boolean;
  isLoading: boolean;
}) {
  const canReadHotel = !isLoading && isHotelEnabled && canAccessHotel;
  return {
    canReadHotel,
    canWriteHotel: canReadHotel && canWrite,
    isLoading,
  };
}

/** Shared client affordance; the API checks the tenant flag and user permissions again. */
export function useHotelAccess() {
  const featureFlags = useTenantFeatureFlags();
  const permissions = usePermissions();
  return resolveHotelAccess({
    isHotelEnabled: featureFlags.isHotelEnabled,
    canAccessHotel: permissions.canAccessHotel,
    canWrite: permissions.canWrite,
    isLoading: featureFlags.isLoading || permissions.isLoading,
  });
}
